import { MATERIAL_TO_MATERIAL_MODE } from 'Pods/ThreeDStudio/constants'
import { MODEL_ID } from 'Pods/ThreeDStudio/Store/constants'

const PROVIDER_KEY = 'tripo3d'

/**
 * Inverse of parseTripo3dTextTo3dDefaultData. Builds an openedModel-shaped
 * payload from the current modelSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dTextTo3dDefaultData
 */
export const buildTripo3dTextTo3dDefaultFromState = (state, id) => {
  const {
    prompt,
    material,
    targetPolycount,
    polygonType,
    isPrivate,
    isSmartLowPoly,
    selectedUseCase,
  } = state.modelSettings || {}
  const materialMode = material != null ? MATERIAL_TO_MATERIAL_MODE[material] : undefined

  return {
    id,
    providerKey: PROVIDER_KEY,
    providerModelId: MODEL_ID.TRIPO3D_TEXT_TO_3D_DEFAULT,
    prompt,
    private: isPrivate,
    useCase: selectedUseCase,
    providerRunAttributes: {
      ...(targetPolycount != null && { poly_count: targetPolycount }),
      ...(polygonType != null && { topology: polygonType }),
      ...(materialMode != null && { materialMode }),
      ...(isSmartLowPoly && { generateType: 'LowPoly' }),
    },
  }
}
